/**
 * Copiar texto para a área de transferência
 * @param {Component} input Campo com o texto a ser copiado
 * @param {Vue} inst Instância (this do componente)
 */
export const copyToClipboard = (input, inst) => {
  input.select()
  try {
    const r = document.execCommand('copy')
    if (r) {
      inst.$showSnack({
        text: 'Texto copiado com sucesso',
        button: true,
      })
      return true
    } else {
      inst.$showSnack({
        text: 'Não foi possível copiar o texto',
        button: true,
      })
    }
  } catch (e) {
    inst.$showSnack({
      text: 'Não é possível copiar textos',
      button: true,
    })
  }
  return false
}

export const copy = (text) => {
  try {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text)
    }
  } catch (err) {
    console.error(err)
  }
  return Promise.reject(new Error('The Clipboard API is not available.'))
}

export default {
  copyToClipboard,
  copy,
}
